import React from 'react';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Container, Button, Chip, Stack, CardMedia } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GitHub as GitHubIcon, OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { projects } from '../utils/Project';

const ProjectDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const project = projects[Number(id)];

  if (!project) {
    return (
      <Container maxWidth="sm" sx={{ py: 10 }}>
        <Typography variant="h4" gutterBottom>Project Not Found</Typography>
        <Button variant="contained" onClick={() => navigate(-1)} startIcon={<ArrowBackIcon />}>Go Back</Button>
      </Container>
    );
  }

  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="md">
        <Button
          variant="text"
          startIcon={<ArrowBackIcon />}
          component={RouterLink}
          to="/projects"
          sx={{ mb: 3 }}
        >
          Back to Projects
        </Button>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
          <CardMedia
            component="img"
            image={project.image}
            alt={project.title}
            sx={{ width: { xs: '100%', md: 350 }, height: 250, objectFit: 'cover', objectPosition: project.title === 'Bandominium' ? 'top' : 'center', borderRadius: 2, boxShadow: 3 }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography variant="h3" gutterBottom>{project.title}</Typography>
            <Typography variant="h6" color="text.secondary" gutterBottom>{project.summary}</Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 2, flexWrap: 'wrap', gap: 1, alignItems: 'flex-start', pl: 0 }}>
              {project.tags.map((tag, i) => (
                <Chip key={i} label={tag} size="small" color="primary" variant="outlined" />
              ))}
            </Stack>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line', mb: 3 }}>{project.details}</Typography>
            <Stack direction="row" spacing={2}>
              {project.githubUrl && (
                <Button
                  variant="outlined"
                  startIcon={<GitHubIcon />}
                  href={project.githubUrl || ''}
                  target={project.githubUrl ? '_blank' : undefined}
                  rel={project.githubUrl ? 'noopener noreferrer' : undefined}
                >
                  Code
                </Button>
              )}
              {project.liveUrl && (
                <Button
                  variant="contained"
                  startIcon={<OpenInNewIcon />}
                  href={project.liveUrl || ''}
                  target={project.liveUrl ? '_blank' : undefined}
                  rel={project.liveUrl ? 'noopener noreferrer' : undefined}
                >
                  View Site
                </Button>
              )}
            </Stack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ProjectDetails;
